import { IPromise, ICrutchBlob } from '../ISignatureApplet';
import { Deferred } from './Deferred';
import { CryptoClient } from '..';

/**
 * Конвертирует {@type Blob} в строку {@type ICrutchBlob}, строку оставляет как есть
 * @param data
 */
export function toCrutchBlob(data: Blob | ICrutchBlob): IPromise<ICrutchBlob> {
    if (window['Blob'] && data instanceof Blob) {
        return blobToCrutchBlob(<Blob>data);
    }
    const deferred = new Deferred<ICrutchBlob>();
    deferred.resolve(<ICrutchBlob>data);
    return deferred;
}

function blobToCrutchBlob(blob: Blob): IPromise<ICrutchBlob> {
    const deferred = new Deferred<ICrutchBlob>();

    const reader = new FileReader();

    reader.onload = function () {
        const str: string = (this.result as string || '').replace(/^data:(.{0,99},)?/, '');
        deferred.resolve({
            content: str,
            encoding: 'base64'
        });
    };

    reader.onerror = function () {
        deferred.reject({
            code: 'E_INVALID_DATA',
            message: 'Cannot convert Blob to base64',
            args: {
                originalError: reader.error
            }
        });
    };

    reader.readAsDataURL(blob);

    return deferred;
}

function getPort<T>(address: string): IPromise<T> {
    if (CryptoClient.settings.port.value === -1) {
        let url = address + CryptoClient.settings.defaultPort + '/api/gate';
        return sendRequest<T>('GET', url, null, null);
    } else {
        const deferred = new Deferred<T>();
        deferred.resolve(CryptoClient.settings.port.value);
        return deferred;
    }
}

export function send<T>(method: string, address: string, request: string, data: any, success?: (res: any) => T): IPromise<T> {
    const deferred = new Deferred<T>();

    getPort<T>(address).then(
        (p) => {
            CryptoClient.settings.port.value = p;
            let url = address + CryptoClient.settings.port.value + '/api' + request;
            sendRequest<T>(method, url, data, success).then(
                (result) => {
                    deferred.resolve(result);
                },
                (error) => {
                    deferred.reject(error);
                }
            );
        },
        // если не удалось получить порт от коммутатора, то скорее всего используется старая версия криптосервиса,
        // поэтому все запросы отправляем на порт по умолчанию
        (error) => {
            CryptoClient.settings.port.value = CryptoClient.settings.defaultPort;
            let url = address + CryptoClient.settings.port.value + '/api' + request;
            sendRequest<T>(method, url, data, success).then(
                (result) => {
                    deferred.resolve(result);
                },
                (error) => {
                    deferred.reject(error);
                }
            );
        }
    );

    return deferred;
}

function sendRequest<T>(method: string, url: string, data: any, success?: (res: any) => T): IPromise<T> {
    const deferred = new Deferred<T>();
    try {
        const xhr = new XHR();

        xhr.onload = () => {
            const response = JSON.parse(xhr.responseText);
            const xhrStatus = response.status;
            const res = response.content;

            if (xhrStatus > 0 && xhrStatus < 400) {
                deferred.resolve(success ? success(res) : res);
            } else {
                deferred.reject(res);
            }
        };
        xhr.onerror = () => {
            deferred.reject({
                code: 'E_CONNECTION_ERROR',
                message: 'Cannot connect to server'
            });
        };

        xhr.open(method, url);
        xhr.send(JSON.stringify(data));
    } catch (e) {
        deferred.reject({
            code: 'E_CONNECTION_ERROR',
            message: e.message
        });
    }
    return deferred;
}

export function getOptions<T>(vals: T, defs: T): T {
    const opts = {};
    vals = vals || <T>{};

    Object.keys(defs).forEach(key => {
        const val = vals[key];
        opts[key] = val === undefined ? defs[key] : val;
    });

    return <T>opts;
}

declare class XDomainRequest extends XMLHttpRequest { }
const XHR = /MSIE [89]/i.test(navigator.userAgent) ? XDomainRequest : XMLHttpRequest;
